import _ from 'lodash'
import createCrudModule from 'vuex-crud'
import api from 'utils/api'

const customUrlFn = (id, params) => `/projects/${params.project_id}/invoices/${params.invoice_id}/bookings${id ? '/'+id : ''}`;

const state = {
  meta: {},
  isCloning: false
}

const actions = {
  clonex({ commit }, { id, data, config, customUrlFnArgs = [] }) {
    const url = customUrlFn(id, customUrlFnArgs) + '/clone';
    commit('cloneStart')
    
    return api.client.post(url, data, config)
      .then(res => {
        commit('cloneEnd')
        return Promise.resolve(res.data);
      })
      .catch(err => {
        commit('cloneEnd')
        return Promise.reject(err.response.data);
      })
  }
}

const mutations = {
  cloneStart(state) {
    state.isCloning = true;
  },

  cloneEnd(state) {
    state.isCloning = false;
  }
}

export default createCrudModule({
  client: api.client,
  resource: 'bookings',
  parseList: res => res.data,
  parseSingle: res => res.data,
  onFetchListSuccess: (state, { meta }) => {
    if (meta) state.meta = meta;
  },
  customUrlFn,
  state,
  actions,
  mutations
});